import { render, staticRenderFns } from "./RoutePage.vue?vue&type=template&id=06624c82&scoped=true"
import script from "./RoutePage.vue?vue&type=script&lang=js"
export * from "./RoutePage.vue?vue&type=script&lang=js"
import style0 from "./RoutePage.vue?vue&type=style&index=0&id=06624c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06624c82",
  null
  
)

export default component.exports